import apiClient, { getTokenFromLocalStorage } from '../utils/apiClient';

const getBaseUrl = () =>
  process.env.REACT_APP_PUBLIC_BASE_URL || 'http://localhost:8009/api';

export const revenueThresholdAPI = {
  /**
   * Tính ngưỡng tiền đơn tối ưu.
   * @param {Object} data - { startDate, endDate, paymentMethod, targetAmount, tolerance, branchId }
   */
  calculate: async (data) => {
    return apiClient.post({ url: '/revenue-threshold/calculate', data });
  },

  /**
   * Lấy danh sách đơn hàng dưới ngưỡng (phân trang).
   * @param {Object} params - { startDate, endDate, paymentMethod, targetAmount, tolerance, branchId, threshold, page, limit }
   */
  getOrders: async (params = {}) => {
    return apiClient.get({ url: '/revenue-threshold/orders', params });
  },

  /**
   * Xuất CSV đơn hàng dưới ngưỡng. Trả về Blob.
   * @param {Object} params - { startDate, endDate, paymentMethod, targetAmount, tolerance, branchId, threshold }
   */
  exportCsv: async (params = {}) => {
    const token = getTokenFromLocalStorage();
    const search = new URLSearchParams(params).toString();
    const res = await fetch(`${getBaseUrl()}/revenue-threshold/export?${search}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err?.message || 'Xuất CSV thất bại');
    }
    return res.blob();
  },
};
